<template>
  <v-card
    class="d-md-flex px-4 py-3 align-center qr-card-wrapper"
    elevation="4"
    :style="{
      border: `2px solid ${historyState.color}`,
      backgroundColor: historyState.bgColor,
    }"
  >
  <custom-popup
      v-model="showPhone"
      :cons="{ title: 'اطلاعات تماسی کاربر', icon: 'account' }"
      max-width="380"
      class="nfc-card-popup"
      :reloadable="true"
      :persistent="true"
      @close="showPhone = false"
    >
      <v-card class="rounded-0" outlined flat>
        <div class="pa-4 text-center">
          <div class="d-flex flex-column align-center gap-2 pa-2">
            
            <v-chip v-if="info && info.user && info.user.id" small color="grey lighten-3" class="mb-2 font-weight-bold">
              شناسه کاربر: {{ info.user.id }}
            </v-chip>
            <div class="d-flex align-center justify-center font-weight-bold text-subtitle-1">
              <span>{{ getUserPhone || 'بدون شماره تلفن' }}</span>
              <v-btn
                v-if="getUserPhone"
                icon
                small
                class="ms-1"
                @click="copyPhone"
              >
                <v-icon small color="primary">mdi-content-copy</v-icon>
              </v-btn>
            </div>
            <div v-if="getUserName" class="grey--text text--darken-1 text-body-2 mt-1">
              ({{ getUserName.replace('/', '').trim() }})
            </div>

          </div>
        </div>
      </v-card>
    </custom-popup>

    <v-card-actions
      :class="{ 'show-checkbox': showCheck }"
      class="action-select ps-0"
    >
      <v-checkbox
        v-model="checkbox"
        class="ma-0"
        color="primary"
        dense
        hide-details
      />
      <v-spacer />
    </v-card-actions>

    <v-card-text class="py-2 py-md-0 w-fit-content mx-auto ps-0">
      <v-tooltip
        v-if="
          (!info?.img_url || !info?.image) && $attrs.images
        "
        top
      >
        <template v-slot:activator="{ on, attr }">
          <v-btn
            class="rounded-lg px-0"
            color="warning"
            depressed
            min-width="112"
            v-bind="attr"
            @click="
              goto(
                ['qrLink','clickyarseo'].includes(info.type)
                  ? `qr/design2/${!!info.qrId?.replace('?gateway=true','') ? info.qrId?.replace('?gateway=true','') : ''}`
                  : `qr/design/${info.domain.name}${
                      !!info.identifier ? info.identifier : ''
                    }`,
              )
            "
            v-on="on"
          >
            <v-icon>mdi-image-refresh</v-icon>
          </v-btn>
        </template>

        <span>ساخت مجدد تصویر</span>
      </v-tooltip>

      <v-img
        v-else-if="info?.img_url && info?.image && $attrs.images"
        :src="info.img_url"
        contain
        max-height="112"
        max-width="112"
        min-width="112"
      >
        <template v-slot:placeholder>
          <v-skeleton-loader class="rounded" max-width="100%" type="card" />
        </template>
      </v-img>

      <v-tooltip v-else-if="$attrs.images" top>
        <template v-slot:activator="{ on, attr }">
          <v-btn
            :loading="createLoading"
            class="rounded-lg px-0"
            color="success"
            depressed
            min-width="36"
            v-bind="attr"
            @click="createQr"
            v-on="on"
          >
            <v-icon>mdi-qrcode</v-icon>
          </v-btn>
        </template>

        <span>ساخت کیوآر</span>
      </v-tooltip>

      <div
        v-if="info.id"
        class="d-flex justify-center pt-2 text--primary"
        style="font-size: 1.1em"
      >
        شناسه:
        {{ info.id }}
      </div>
    </v-card-text>
    <!--start-->

    <v-card-text class="pa-0">
      <v-card-subtitle class="pa-0 ms-10">
        {{ info.type | qrType("name") }} {{ getUserName }}
        <v-btn small icon @click="showPhone=true"><v-icon small color="red">mdi-phone</v-icon></v-btn>
      </v-card-subtitle>
      <div class="font-size-h6 font-weight-bold">
        
          <v-badge
          v-if="$options.filters.qrType(info.type, 'pro')"
          color="transparent"
          overlap
          offset-x="23"
          offset-y="8"
        >
          <template #badge>
            <v-icon color="primary darken-3" size="13" class="glow-crown">mdi-crown</v-icon>
          </template>
          <v-icon class="me-2 icon-list-type" color="primary darken-3" size="29">mdi-{{ info.type | qrType("icon") }}</v-icon>
        </v-badge>
        <v-icon v-else class="me-2 icon-list-type" color="grey darken-3" size="32">mdi-{{ info.type | qrType("icon") }}</v-icon>
       <div
          v-if="!editTitle"
          class="d-inline-flex align-center"
          style="height: 40px; max-width: calc(100% - 40px);"
        >
          <span class="d-inline-block text-truncate" style="max-width: 150px;" :title="info.title">
            {{ info.title }}
          </span>
          <v-btn icon small @click="editTitle = true" class="ms-1">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
        </div>

        <v-card
          v-else
          v-click-outside="onCloseField"
          class="d-inline-block"
          flat
          max-width="250"
        >
          <v-text-field
            v-model="editedName"
            :disabled="loading"
            :error-messages="errorMessage"
            :hide-details="!errorMessage"
            :loading="loading"
            append-icon="check"
            autofocus
            clearable
            dense
            outlined
            @click:append="updateTitle"
            @click:clear="onCloseField"
            @keydown.enter="updateTitle"
          />
        </v-card>

        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <v-btn
              class="mx-2"
              icon
              small
              v-bind="attr"
              @click="$root.$emit('showHistory', info)"
              v-on="on"
            >
              <v-icon>mdi-history</v-icon>
            </v-btn>
          </template>

          <span>تاریخچه</span>
        </v-tooltip>
        <!-- اضافه شدن وضعیت تاریخچه -->
        <v-chip class="mx-2" :color="historyState.color" dark outlined small>
          <v-icon left small>{{ historyState.icon }}</v-icon>
          {{ historyState.text }}
        </v-chip>
          <qr-tag 
          :info="info" 
          @updated="$emit('fetch')" 
        />
      </div>

      <div
        v-if="$attrs.link"
        class="pt-2 desc-text w-fit-content cursor-pointer"
      >
        <v-icon class="ms-1 me-3" size="22">mdi-link-variant</v-icon>

        <v-tooltip v-model="showTooltip" color="green darken-1" top  v-if="!!displayLink && displayLink?.trim()!==''">
          <template v-slot:activator="{ on, attrs }">
           <a
              :href="isSpecialUser ? '' : validHref"
              class="d-inline-block text-truncate"
              :style="[
                isSpecialUser ? { 'user-select': 'none', 'pointer-events': 'none' } : {},
                { 'max-width': '200px', 'vertical-align': 'middle' }
              ]"
              target="_blank"
              v-on="on"
              v-bind="attrs"
              :title="displayLink"
            >
              {{ displayLink }}
          </a>

          </template>

          <span>کپی شد</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :disabled="isSpecialUser"
              icon
              small
              v-bind="attrs"
              @click="copyUrl"
              v-on="on"
            >
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </template>

          <span>کپی</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              @click="$emit('print-qr', info)"
              v-on="on"
            >
              <v-icon small>mdi-printer-outline</v-icon>
            </v-btn>
          </template>

          <span>پرینت کیوآر</span>
        </v-tooltip>
      </div>

      <div class="d-flex align-center" style="gap: 8px">
        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <div class="pt-2 desc-text w-fit-content" v-bind="attr" v-on="on">
              <v-icon class="ms-1 me-3" size="22">mdi-clock-outline</v-icon>
              {{ info.created_at_diff }}
            </div>
          </template>

          <span style="font-size: 0.8em"
            >ایجاد شده: {{ formattedCreatedAt }}</span
          >
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on, attr }">
            <div class="pt-2 desc-text w-fit-content" v-bind="attr" v-on="on">
              <v-icon class="ms-1 me-3" size="22">mdi-pencil-outline</v-icon>
              {{ info.updated_at_diff }}
            </div>
          </template>
          <span style="font-size: 0.8em"
            >آخرین ویرایش: {{ formattedUpdatedAt }}</span
          >
        </v-tooltip>
      </div>
    </v-card-text>

    <!--end-->
    <v-spacer />

    <v-card-text class="pa-0 w-fit-content text-md-left">
      <span class="font-size-h6 font-weight-bold">{{
        info.clicks || 0 | persianNum
      }}</span>
      <br />
      دیده شده
      <br />
      <v-btn
        class="px-2 mx-n2"
        color="primary"
        small
        text
        @click="
          ['qrLink','clickyarseo'].includes(info.type)
            ? goto(`qr/statistics2/${info.qrId?.replace('?gateway=true','')}`)
            : goto(
                `qr/statistics/${info.domain.name}${
                  !!info.identifier ? info.identifier : ''
                }`,
              )
        "
      >
        <v-icon class="me-1" small> mdi-chevron-right </v-icon>
        مشاهده بیشتر
      </v-btn>

      <v-divider class="my-1" />

      <v-card v-if="$attrs.settings" class="d-flex align-center pa-0" flat>
        <span class="text-nowrap">
          {{ info.sms_count || 0 }}
          : پیامک ارسال شده
        </span>
        <users-picker
          ref="userPicker"
          v-model="pickedUser"
          class="me-n2 ms-2"
          icon
          is-btn
          @input="transferUser"
        />
      </v-card>
    </v-card-text>

    <v-divider class="ma-md-4" vertical />

    <div v-if="!$attrs.settings" class="text-center">
      <div class="py-2">
        <renew-button
          :badge-text="renewBadgeText"
          :badge-color="renewBadgeColor"
          :button-color="renewButtonColor"
          :scale="0.72"
          class="full-width-btn"
          :loading="priceLoading"
          @click="getPrices"
          :badgeOffsetX="75"
          :badgeOffsetY="7"
          :buttonText="$t('assistantChatViewer.renew')"
        />
      </div>
      <v-btn
        color="primary"
        min-width="100"
        outlined
        @click="$root.$emit('fillInfo', info)"
        class="full-width-btn"
      >
        دانلود
        <v-icon class="ms-1" small>mdi-download</v-icon>
      </v-btn>
    </div>

    <v-card-actions v-else class="position-relative flex-wrap pa-0">
      <div
        style="width: 100%; top: -40px; position: absolute"
        class="pa-0 d-flex justify-center"
      >
        <renew-button
          :badge-text="renewBadgeText"
          :badge-color="renewBadgeColor"
          :button-color="renewButtonColor"
          :scale="0.75"
          :loading="priceLoading"
          @click="getPrices"
          :badgeOffsetX="68"
          :badgeOffsetY="7"
          :buttonText="$t('assistantChatViewer.renew')"
        />
      </div>
      <v-btn
        v-if="info.status === 'active'"
        color="primary"
        min-width="100"
        outlined
        @click="$root.$emit('fillInfo', info)"
      >
        دانلود
        <v-icon class="ms-1" small>mdi-download</v-icon>
      </v-btn>

      <v-btn
        v-else
        color="success"
        dark
        depressed
        min-width="100"
        @click="showPause('active')"
      >
        فعال کردن
        <v-icon class="ms-1" small>mdi-reload</v-icon>
      </v-btn>

      <div class="more-actions desc-text pa-2 mx-auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :href="
                findEditPage(
                  info?.domain?.name,
                  info.identifier,
                  info.type,
                  info.qrId?.replace('?gateway=true',''),
                )
              "
              icon
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>

          <span>ویرایش</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              @click="
                goto(
                  ['qrLink','clickyarseo'].includes(info.type)
                    ? `qr/design2/${!!info.qrId?.replace('?gateway=true','') ? info.qrId?.replace('?gateway=true','') : ''}`
                    : `qr/design/${info.domain.name}${
                        !!info.identifier ? info.identifier : ''
                      }`,
                )
              "
              v-on="on"
            >
              <v-icon small>mdi-palette</v-icon>
            </v-btn>
          </template>

          <span>دیزاین</span>
        </v-tooltip>

        <v-tooltip v-if="info.status === 'active'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              @click="
                ['qrLink','clickyarseo'].includes(info.type)
                  ? goto(`qr/setting2/${info.qrId?.replace('?gateway=true','')}`)
                  : goto(
                      `qr/setting/${info.domain.name}${
                        !!info.identifier ? info.identifier : ''
                      }`,
                    )
              "
              v-on="on"
            >
              <v-icon small>mdi-cogs</v-icon>
            </v-btn>
          </template>

          <span>تنظیمات کیوآر</span>
        </v-tooltip>

        <v-tooltip v-if="info.status === 'active'" bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              @click="showPause('deactivate')"
              v-on="on"
            >
              <v-icon small>mdi-pause</v-icon>
            </v-btn>
          </template>

          <span>متوقف کردن</span>
        </v-tooltip>

        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              v-bind="attrs"
              @click="$root.$emit('fillInfo', info)"
              v-on="on"
            >
              <v-icon small>mdi-download</v-icon>
            </v-btn>
          </template>

          <span>دانلود</span>
        </v-tooltip>

        <v-tooltip
          v-if="ribbon_can('delete_monitoring')"
          bottom
          color="red darken-1"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-hover v-slot="{ hover }">
              <v-btn
                :color="hover ? 'red darken-2' : ''"
                icon
                small
                v-bind="attrs"
                @click="showDestroy"
                v-on="on"
              >
                <v-icon small>mdi-delete</v-icon>
              </v-btn>
            </v-hover>
          </template>

          <span>حذف</span>
        </v-tooltip>
      </div>
    </v-card-actions>
  </v-card>
</template>

<script>
import DownloadFile from "../../../qrland/downloadFile";
import UsersPicker from "../../../../components/pickers/usersPicker";
import mixin from "../../../../../mixin";
import renewButton from "../../../qrland/components/renewButton.vue";
import { mapActions } from "vuex";
import QrTag from "./QrTag.vue"; 

export default {
  name: "cardMonitoring",

  components: { UsersPicker, DownloadFile, renewButton, QrTag },
  mixins: { mixin },
  props: {
    info: Object,
    showCheck: Boolean,
    value: Boolean,
    priceLoading: false,
  },

  data: () => ({
    showPhone:false,
    editTitle: false,
    editedName: "",
    errorMessage: null,
    showTooltip: false,
    checkbox: false,
    loading: false,
    pickedUser: null,
    createLoading: false,
  }),

  mounted() {
    this.editedName = this.info.title;

    this.setCreatedQrID(this.info.id);
  },

  computed: {
   validHref() {
    let link = this.info?.dest_link ?? this.qrLink;
    
    if (!link) return '#';

    if (!/^https?:\/\//i.test(link)) {
      return `https://${link}`;
    }
    
    return link;
  },
    historyState() {
      const dateStr =
        this.info.History_max_remind_date || this.info.history_max_remind_date;

      if (!dateStr) {
        return {
          text: "بدون تاریخچه",
          color: "#F7DC45",
          bgColor: "#F7DC451A",
          icon: "mdi-history-off",
          value: "empty",
        };
      }

      const remindDate = new Date(dateStr);
      const now = new Date();
      if (
        remindDate.toDateString() === now.toDateString() &&
        remindDate >= now
      ) {
        return {
          text: "زمان آخرین یادآوری رسیده",
          value: "now",
          color: "#ca3102",
          bgColor: "#ca31021A",
          icon: "mdi-bell-ring",
        };
      }
      if (remindDate < now) {
        return {
          text: "زمان یادآوری گذشته",
          value: "passed",
          color: "#8B0700",
          bgColor: "#8B07001A",
          icon: "mdi-bell-alert",
        };
      }

      return {
        text: "دارای تاریخچه",
        value: "has",
        color: "#6CF76C",
        bgColor: "#6CF76C1A", // پس‌زمینه کمرنگ
        icon: "mdi-history",
      };
    },
    daysRemaining() {
      return this.getUntilExpire(this.getExpireAt);
    },

    renewBadgeText() {
      return this.getTypeText(this.daysRemaining, true);
    },

    renewButtonColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-1",
        "in-month": "amber darken-2",
        "in-days": "amber darken-3",
        "in-expire": "red darken-2",
      };
      return colorMap[colorClass] || "red darken-2";
    },

    renewBadgeColor() {
      const colorClass = this.$options.filters.expireColor(this.daysRemaining);
      const colorMap = {
        "": "green darken-2",
        "in-month": "amber darken-3",
        "in-days": "orange lighten-1",
        "in-expire": "red darken-3",
      };
      return colorMap[colorClass] || "red darken-2";
    },
    // isMobile() {
    //   return this.$vuetify.breakpoint.mobile
    // },
    // formattedParentDate() {
    //   this.selectedDate='';
    //   return selectedDate ? this.dateString(selectedDate) : "";
    // },

    isSpecialUser() {
      return this.info?.user_id === 4;
    },
    qrLink() {
      let link = this.info.domain?.name || "";
      if (!link.startsWith("http")) {
        link = "https://" + link;
      }

      if (!!this.info?.identifier) return link + this.info.identifier;
      return link;
    },
    displayLink() {
      let rgx = /^(http|https):\/\//gm;
      return this.info?.dest_link??this.qrLink.split("?")[0].replace(rgx, "");
    },
    getExpireAt() {
      return this.info.prices &&
        this.info?.prices?.length > 0 &&
        this.info.prices?.[0]?.expire_at
        ? this.info.prices?.[0]?.expire_at
        : this.info?.expired_at||this.info?.expire_at;
    },
    getUserName() {
      let user = "";

      if (this.info && this.info.user) {
        user = " / " + this.info.user?.name + " " + this.info.user?.lastName;
      }
      return user;
    },
    getUserPhone() {
      let phone = "";

      if (this.info && this.info.user) {
        phone = this.info.user?.phone;
      }
      return phone;
    },

    getImage() {
      return this.info?.img_url
        ? this.info?.img_url
        : `${this.$qrUrl}/qr/${this.info.image}`;
      // return `http://127.0.0.1:8001/qr/${this.info.image}`
    },
    formattedCreatedAt() {
      // return this.dateString(this.info.created_at);
      const miladiDate = this.info.created_at;
      return this.jalalian(this.info.created_at);
    },
    formattedUpdatedAt() {
      // return this.dateString(this.info.updated_at);
      // return this.info.updated_at;
      const miladiDate = this.info.updated_at;
      return this.jalalian(this.info.updated_at);
    },
  },

  watch: {
      info: {
      deep: true,
      immediate: true, 
      handler(val) {
        if (val && val.user_register !== undefined) {
          this.setRegisterOnline(val.user_register);
        }
      }
    },
    showTooltip(val) {
      if (val) {
        setTimeout(() => {
          this.showTooltip = false;
        }, 2000);
      }
    },
    value(val) {
      this.checkbox = val;
    },
    checkbox(val) {
      this.$emit("input", val);
    },
    editTitle(val) {
      if (val) {
        this.editedName = this.info.title;
      }
    },
  },

  methods: {
    ...mapActions("localstorage", [
      "setCreatedQrID",
      "setQrType",
      "setRegisterOnline",
    ]),
    findEditPage(name, id, type, qrid) {
      qrid=qrid?.replace('?gateway=true','');
      const types = {
        visitcard: `#/qr/edit/${name}${!!id ? id : ""}`,
        visitcardpro: `#/qr/editpro/${name}${!!id ? id : ""}`,
        business: `#/qr/editBpage/${name}${!!id ? id : ""}`,
        socialmedia: `#/qr/editSocial/${name}${!!id ? id : ""}`,
        commericial: `#/qr/editCpage/${name}${!!id ? id : ""}`,
        qrlist: `#/qr/qrlist/${!!id ? id : ""}`,
        goldlabel: `#/qr/goldlabel/${name}${!!id ? id : ""}`,
        labelproduct: `#/qr/labelproduct/${name}${!!id ? id : ""}`,
        voicegallery: `#/qr/editVoice/${name}${!!id ? id : ""}`,
        voicegallerypro: `#/qr/editVoicePro/${name}${!!id ? id : ""}`,
        consultationqr: `#/qr/consultationQrEdit/${name}${!!id ? id : ""}`,
        qrlink: `#/qr/link/${!!qrid ? qrid : ""}`,
        clickyarseo: `#/qr/linkpro/${!!qrid ? qrid : ""}`,
        videogallery: `#/qr/editVideo/${name}${!!id ? id : ""}`,
        photogallery: `#/qr/editPhoto/${name}${!!id ? id : ""}`,
        singleproduct: `#/qr/product/${name}${!!id ? id : ""}`,
        menu: `#/qr/editMenu/${name}${!!id ? id : ""}`,
        bshop: `#/qr/editBShop/${name}${!!id ? id : ""}`,
        application: `#/qr/editApplication/${name}${!!id ? id : ""}`,
        cshop: `#/qr/editCShop/${name}${!!id ? id : ""}`,
        appointment: `#/qr/editAppointment/${name}${!!id ? id : ""}`,
        insurance: `#/qr/insurance/${name}${!!id ? id : ""}`,
        wheel: `#/qr/luck-wheel/${name}${!!id ? id : ""}`,
        multicard: `#/qr/multicard/${name}${!!id ? id : ""}`,
        feedbackgallery: `#/qr/editFeedback/${name}${!!id ? id : ""}`,
        productpro: `#/qr/productPro/${name}${!!id ? id : ""}`,
        pdfgallery: `#/qr/editPdf/${name}${!!id ? id : ""}`,
        catalog: `#/qr/editcatalog/${name}${!!id ? id : ""}`,
        gift:`#/qr/editgift/${name}${!!id ? id : ""}`,
        text:`#/qr/editText/${name}${!!id ? id : ""}`,
        qrbale:`#/qr/editBale/${name}${!!id ? id : ""}`,
        qrrobika:`#/qr/editRobika/${name}${!!id ? id : ""}`,
        qreitaa:`#/qr/editEitaa/${name}${!!id ? id : ""}`,
        pricelabel: `#/qr/labelprice/${name}${!!id ? id : ""}`,
        attendanceqr: `#/qr/editattendance/${name}${!!id ? id : ""}`,     



      };

      return types[type.toLowerCase()];
    },
    copyPhone() {
      const phone = this.getUserPhone;
      if (phone) {
        navigator.clipboard.writeText(phone);
        this.$toast ? this.$toast.success("شماره تلفن کپی شد") : alert("شماره تلفن کپی شد");
      }
    },
    copyUrl() {
      if (this.info?.domain) {
        navigator.clipboard.writeText(this.qrLink);
        this.showTooltip = true;
      }else if(this.info?.dest_link){
        navigator.clipboard.writeText(this.info.dest_link);
        this.showTooltip = true;
      }
    },
    onCloseField() {
      this.errorMessage = null;
      this.editTitle = false;
    },
    updateTitle() {
      if (!this.editedName || this.editedName.length <= 0) {
        this.errorMessage = "نام کارت ویزیت را به درستی وارد نمایید!";
        return;
      }

      this.loading = true;
      this.$api
        .put("/v1/testQr/update",
                  ["qrlink",'clickyarseo'].includes(this.info.type.trim().toLowerCase())
            ? {
                qr_id: this.info?.qrId?.replace('?gateway=true',''),
                title: this.editedName,
                type:this.info.type.trim()
              }
            : {
                qr_id: this.info?.qrId?.replace('?gateway=true',''),
                domain: this.info?.domain?.name || "qrland.in",
                identifier: this.info?.identifier || "",
                title: this.editedName,
              })
        .then(({ data }) => {
          this.onCloseField();
          this.info.title = this.editedName;
          this.$emit("fetch");
        })
        .finally(() => (this.loading = false));
    },
    async showDestroy() {
      if (await this.$modal.yesNo("آیا از حذف کیوآر مطمئن هستید؟")) {
        this.destroy();
      }
    },
    destroy() {
      this.loading = true;

      this.$api
        .delete(`/v1/testQr/delete`, {
          params:
            !["qrLink",'clickyarseo'].includes(this.info?.type)
              ? {
                  domain: this.info?.domain?.name,
                  identifier: this.info?.identifier || "",
                }
              : {
                  qr_id: this.info?.id,
                },
        })
        .then(({ data }) => {
          this.$toast.success("کیوآر با موفقیت حذف شد.");
          this.$emit("fetch");
        })
        .catch(({ response }) => console.log("error in delete qr: ", response))
        .finally(() => (this.loading = false));
    },
    async showPause(input) {
      let msg =
        input === "deactivate"
          ? "آیا از متوقف کردن کیوآر مطمئن هستید؟"
          : "آیا از فعال کردن کیوآر مطمئن هستید؟";
      if (await this.$modal.yesNo(msg)) {
        this.disable(input);
      }
    },
    disable(input) {
      this.loading = true;

      this.$api
        .put("/v1/testQr/update", {
          domain: this.info.domain?.name,
          identifier: this.info.identifier || "",
          status: input,
          qr_id: this.info.qrId?.replace('?gateway=true',''),
        })
        .then(({ data }) => {
          let s = { active: "فعال", deactivate: "متوقف" };
          this.$toast.success(`کیوآر با موفقیت ${s[input]} شد.`);
          this.$emit("fetch");
        })
        .catch(({ response }) => console.log("error in paused qr: ", response))
        .finally(() => (this.loading = false));
    },
    getPrices() {
      this.$root.$emit("getPrices", this.info);
    },
    transferUser(e) {
      this.loading = true;

      this.$api
        .put(
          "/admin/transfer-qr",
          {},
          {
            params: {
              qr: this.info.id,
              user: e,
            },
          },
        )
        .then(({ data }) => {
          if (
            data &&
            data.status &&
            (data.status === true || data.status === "200")
          ) {
            this.$toast.success("کاربر با موفقیت انتقال یافت");
            this.$refs.userPicker.dialog = false;
          } else {
            this.$toast.error("مشکلی در انتقال رخ داده است!");
          }
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در انتقال کاربر!");
        })
        .finally(() => (this.loading = false));
    },
    createQr() {
      this.createLoading = true;

      this.$api
        .post("/admin/create-qr", {
          qr_id: this.info.id,
          qr: {
            section: "#link",
            backcolor: "#ffffff",
            frontcolor: "#000000",
            gradient_color: "#000000",
            marker_out_color: "#000000",
            marker_in_color: "#000000",
            marker_top_right_outline: "#000000",
            marker_top_right_center: "#000000",
            marker_bottom_left_outline: "#000000",
            marker_bottom_left_center: "#000000",
            framecolor: "#000000",
            optionlogo: "none",
            "logo-size": 100,
            marker: "default",
            marker_in: "default",
            outer_frame: "none",
            framelabel: "SCAN ME",
            label_font: "AbrilFatface.svg",
            "label-text-size": 100,
            size: "248",
            level: "M",
          },
        })
        .then(({ data }) => {
          this.$toast.success("با موفقیت ساخته شد");
          this.$emit("fetch");
        })
        .catch(({ response }) => {
          this.$toast.error("ساخت کیوآر با خطا روبرو شد!");
          console.log("error in create qr: ", response);
        })
        .finally(() => (this.createLoading = false));
    },
  },
};
</script>

<style scoped>
.v-card {
  background-color: #f5f5f5;
  border-radius: 8px;
  padding: 16px;
}

.v-divider {
  margin: 16px 0;
}

.v-list-item {
  padding: 0;
}

.v-list-item-content {
  margin-left: 0;
}

.v-btn {
  text-transform: none;
}
</style>

<style scoped>
.v-tab--active {
  border-bottom: 2px solid var(--v-primary-base);
}

@media screen and (min-width: 960px) {
  .qr-card-wrapper:hover >>> .more-actions,
  .qr-card-wrapper:hover >>> .action-select,
  .qr-card-wrapper >>> .action-select.show-checkbox {
    visibility: visible !important;
  }

  .qr-card-wrapper:hover >>> .icon-list-type {
    transition: all 0.25s ease-in-out;
    transform: scale(1.1);
  }

  .expire-option {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateY(calc(-100% - 10px)) translateX(-50%);
  }

  .action-select {
    /*position: absolute;*/
    right: 0;
    top: 0;
    visibility: hidden;
    height: 100%;
    z-index: 2;
  }

  .more-actions {
    visibility: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    transform: translateY(calc(100% + 5px));
  }
}

.qr-card-wrapper.in-expire {
  border: 1px solid rgb(255, 11, 11);
  box-shadow: none !important;
}

.expire-option {
  width: fit-content;
  white-space: nowrap;
  padding: 2px 8px;
  text-align: center;
  border-radius: 4px;
  background-color: forestgreen;
  color: white;
}

.expire-option.in-month {
  background-color: var(--v-warning-base);
}

.expire-option.in-days {
  background-color: rgb(250, 172, 77);
}

.expire-option.in-expire {
  background-color: var(--v-third-base);
}

.desc-text,
.desc-text >>> a,
.desc-text >>> .v-icon:not(:hover) {
  color: #c2c2c2;
}

.w-fit-content {
  width: fit-content;
}
.full-width-btn {
  width: 100% !important;
  max-width: 100% !important;
  min-width: 100% !important;
}

.full-width-btn >>> .v-btn {
  width: 100% !important;
}

.full-width-btn >>> .renew-button {
  width: 100% !important;
}
</style>
